<template>
    <v-layout row justify-center>
        <v-dialog :value="visible" @input="$emit('switch')" max-width="500px">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold orange">Captain Going Offline
                </v-card-title>
                <v-card-text>
                    <v-layout row style="text-align: center;margin: 10px">
                        <v-flex xs2>
                            <b>Captain</b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.captain_name}}
                        </v-flex>
                    </v-layout>
                    <v-layout row style="text-align: center;margin: 10px">
                        <v-flex xs2>
                            <b>To </b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.destination || 'No Destination'}}
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "going-offline-dialog",
        props: {
            data: {
                type: Object
            },
            visible: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>